import api from '@pray/shared/utils/api';

export const createSocialClips = async ({ artistId = null, contentId = null, creditConfirmationId = null } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/social-clips`;
  await api.executePostRequest(
    url,
    creditConfirmationId ? { credit_confirmation_id: creditConfirmationId } : undefined
  );
};
